import { useState } from 'react';

import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { prepareFilter } from 'libs/common';
import { CashboxGrid } from './grid';
import Filter from './filter';

const sortInitial = [{ field_name: 'timestamp', direction: 'desc' }];
const itemsInitial = {};

export const Cashbox = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('cashbox', sortInitial);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    //console.log('🚀 ~ prepareParams ~ data:', data);
    const intFields = ['shift'];
    const toggleFields = ['result'];
    const priceFields = ['amount_from', 'amount_to'];
    const plateFields = ['vehicle_plate'];
    const addParams = {};
    return prepareFilter(data, addParams, { toggleFields, intFields, priceFields, plateFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller {...props} {...gridParams} {...gridActions} type="payment" filterName="paymentFilter" grid={CashboxGrid} gridFilter={Filter} getRequestParams={prepareParams} />
  );
};
